import LocationCard from './LocationCard';

export default LocationCard;
